import { message } from 'antd'
import Cookies from 'universal-cookie'
import { history } from 'umi';
import { login, send, relogin, logout, passwordUpdate } from 'services/user'

const cookies = new Cookies()

const initState = {
    login: false,
    user: JSON.parse(localStorage.getItem('sw_user')) || {},
    menuPopoverVisible: false,
    siderFold: localStorage.getItem('antdAdminSiderFold') === 'true',
    darkTheme: localStorage.getItem('antdAdminDarkTheme') !== 'false',
    isNavbar: document.body.clientWidth < 769,
    tags: [],
    columns: [],
}

const roles = [
    "系统管理/导入源管理","系统管理/源绑定标签ID管理","系统管理/非原创管理",
    "系统管理/用户列表","系统管理/标签管理","系统管理/归一词管理","系统管理/敏感词管理","系统管理/屏蔽词管理","系统管理/分类管理","系统管理/分发人员KPI","系统管理/外部权限管理",
    "外部内容审核/待审核","外部内容审核/已通过","外部内容审核/回收库","外部内容审核/三审入库",
    "新闻分发/分发审核","新闻分发/审核中","新闻分发/复审库","新闻分发/待审库","新闻分发/已发布","新闻分发/已删除","新闻分发/已过滤",
    "公告分发/分发审核","公告分发/审核中","公告分发/待审库","公告分发/已发布","公告分发/已删除","公告分发/已发至财联社",
    "互动平台自动写稿/提示词设置","互动平台自动写稿/屏蔽词设置","互动平台自动写稿/高亮关键词","互动平台自动写稿/分发审核","互动平台自动写稿/审核中","互动平台自动写稿/待审库","互动平台自动写稿/已发布","互动平台自动写稿/已删除","互动平台自动写稿/已发至财联社",
    "公告自动写稿/审核中","公告自动写稿/待审核","公告自动写稿/已发布","公告自动写稿/已删除","公告自动写稿/已发至财联社","公告自动写稿/高亮关键词",
    "研报自动写稿/审核中","研报自动写稿/待审核","研报自动写稿/已发布","研报自动写稿/已删除",
    "其它分发/分发审核","其它分发/审核中","其它分发/待审库","其它分发/已发布","其它分发/已删除","其它分发/已发至财联社",
    "非标分发/分发审核","非标分发/审核中","非标分发/待审库","非标分发/已发布","非标分发/已删除","非标分发/已发至财联社",
    // "改写分发/分发审核","改写分发/审核中","改写分发/待审库","改写分发/已发布","改写分发/已删除","改写分发/已发至财联社",
    "盘面直播/分发审核","盘面直播/审核中","盘面直播/待审库","盘面直播/已发布","盘面直播/已删除","盘面直播/已发至财联社",
    "一图看懂招股书/一图看懂招股书",
    "大宗交易分发/已发布","大宗交易分发/已删除",
    "龙虎榜分发/已发布","龙虎榜分发/已删除",
    "行情分发/已发布","行情分发/已删除","互动平台自动写稿/机器过滤","文字转语音/早报","文字转语音/FM",
    "基金公告自动写稿/提示词设置","基金公告自动写稿/审核中","基金公告自动写稿/待审核","基金公告自动写稿/已发布","基金公告自动写稿/已删除",
    "科日自动写稿/提示词设置","科日自动写稿/审核中","科日自动写稿/待审核","科日自动写稿/已发布","科日自动写稿/已删除",
    "港股公告自动写稿/审核中","港股公告自动写稿/待审核","港股公告自动写稿/已发布至话题","港股公告自动写稿/已发布至电报流","港股公告自动写稿/已删除","港股公告自动写稿/高亮关键词",
    "港股研报自动写稿/审核中","港股研报自动写稿/待审核","港股研报自动写稿/已发布至话题","港股研报自动写稿/已发布至电报流","港股研报自动写稿/已删除",
    "美股研报自动写稿/审核中","美股研报自动写稿/待审核","美股研报自动写稿/已发布","美股研报自动写稿/已删除",
    "涨停原因分发/已发布","涨停原因分发/已删除",
    "债券公告自动写稿/审核中","债券公告自动写稿/待审核","债券公告自动写稿/已发布","债券公告自动写稿/备用稿件库","债券公告自动写稿/已删除","债券公告自动写稿/高亮关键词",
    "金融处罚自动写稿/审核中","金融处罚自动写稿/待审核","金融处罚自动写稿/已发布","金融处罚自动写稿/已删除",
    "自动评论自动写稿/提示词设置","自动评论自动写稿/文章列表",
    "两融动态分发/已发布","两融动态分发/已删除",
    "沪深股通分发/已发布","沪深股通分发/已删除",
    "热榜分发/已发布","热榜分发/已删除",
    "主力资金-板块分发/已发布","主力资金-板块分发/已删除",
    "主力资金-个股分发/已发布","主力资金-个股分发/已删除",
    "概念动态分发/已发布","概念动态分发/已删除",
    "北交所自动写稿/审核中","北交所自动写稿/待审核","北交所自动写稿/已发布至话题","北交所自动写稿/已发布至电报流","北交所自动写稿/已删除","北交所自动写稿/高亮关键词",
    "AI公告长文扩写/审核中","AI公告长文扩写/待审核","AI公告长文扩写/已发布","AI公告长文扩写/已删除","AI公告长文扩写/已发至财联社","AI公告长文扩写/提示词设置",
];

export default {
    namespace: 'app',
    state: initState,

    effects: {
        *login({user}, { call, put }) {
            user.roles = user.role === "ADMIN" ? roles : roles.filter(r => r.indexOf('系统管理') === -1 && r.indexOf('新闻分发/复审库') === -1);
            console.log('登录后:', user)
            yield put({ type: 'setUser', user })
            cookies.set('access_token', user.token, { path: '/' })
            history.push('/')
        },
        *sendCode({payload}, { call, put }) {
            const data = yield call(send, payload)
            message.info('发送成功')
        },
        *relogin(_, { call, put }) {
            const user = yield call(relogin);
            user.roles = roles;
            yield put({ type: 'setUser', user })
            cookies.set('access_token', user.token, { path: '/' })
        },
        *logout(_, { put }) {
          try {
            yield put({ type: 'doLogout' })
            history.push('/login');
          } catch (e) {
              console.error('LOGOUT FAILED: %o', e)
          }
        },
        *passwordAmend({payload}, { call, put }) {
            yield call(passwordUpdate, payload)
            message.success("密码修改成功")
        },

        *switchSider({ payload }, { put }) {
          yield put({
              type: 'handleSwitchSider',
          })
        },

        *changeTheme({ payload }, { put }) {
            yield put({
                type: 'handleChangeTheme',
            })
        },

        *changeNavbar({ payload }, { put }) {
            if (document.body.clientWidth < 769) {
                yield put({ type: 'showNavbar' })
            } else {
                yield put({ type: 'hideNavbar' })
            }
        },

        *switchMenuPopver({ payload }, { put }) {
            yield put({
                type: 'handleSwitchMenuPopver',
            })
        },
    },
    reducers: {
      setUser(state, { user }) {
        localStorage.setItem('sw_user', JSON.stringify(user))
        state.user = user;
      },

      doLogout() {
          cookies.remove('access_token')
          localStorage.removeItem('sw_user')
          return initState
      },

      showLoading(state) {
        state.loading = true
      },
      hideLoading(state) {
        state.loading = false
      },
      handleSwitchSider(state) {
          localStorage.setItem('antdAdminSiderFold', !state.siderFold)
          state.siderFold = !state.siderFold
      },
      handleChangeTheme(state) {
          localStorage.setItem('antdAdminDarkTheme', !state.darkTheme)
          state.darkTheme = !state.darkTheme
      },
      showNavbar(state) {
          state.isNavbar = true
      },
      hideNavbar(state) {
          state.isNavbar = false
      },
      handleSwitchMenuPopver(state) {
          return {
              ...state,
              menuPopoverVisible: !state.menuPopoverVisible,
          }
      },
      setTags(state, { tags }) {
          return {...state, tags}
      },
      setColumns(state, { columns }) {
          return {...state, columns}
      },
    },
}

